import { gql } from 'apollo-angular';
import { Group } from '../../entities/group/group';

export const UPDATE_GROUP_MUTATION = gql`
mutation updateGroup($input: GroupInput) {
  updateGroup(input: $input) {
    id
  }
}
`;

export const CREATE_GROUP_MUTATION = gql`
mutation createGroup($input: GroupInput) {
  createGroup(input: $input) {
    id
  }
}
`;

export const DELETE_GROUP_MUTATION = gql`
mutation deleteGroup($id: String) {
  deleteGroup(id: $id)
}
`;

export const GET_GROUPS_QUERY = gql`
query groups{
  getGroups{
    id
    name
  }
}
`;

export interface GetGroupsResponse {
  getGroups: Group[];
  loading: boolean;
}
